/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSetDefaultVersionPartialUpdateBody = zod.strictObject({
    default_version: zod.number().optional(),
});

export type ApiAccountsSetDefaultVersionPartialUpdateBody = zod.input<
    typeof ApiAccountsSetDefaultVersionPartialUpdateBody
>;
export type ApiAccountsSetDefaultVersionPartialUpdateBodyOutput = zod.output<
    typeof ApiAccountsSetDefaultVersionPartialUpdateBody
>;
